import React, { useState } from 'react';
import { WardsData } from '../../Datas/WardsData';
import IndentModal from '../IndentModal/IndentModal';
import DrugConModal from '../DrugConModal/DrugConModal';
import WardInventoryModal from '../WardInventoryModal/WardInventoryModal';
import RegisterWardModal from './RegisterWardModal';
import './WardsModal.css';

const WardsModal = () => {
  const [selectedWard, setSelectedWard] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDrugConModalOpen, setIsDrugConModalOpen] = useState(false);
  const [isInventoryModalOpen, setIsInventoryModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isIndentModalOpen, setIsIndentModalOpen] = useState(false);
  const [selectedIndent, setSelectedIndent] = useState(null);

  const handleOpenRegisterModal = () => {
    setIsRegisterModalOpen(true);
  };

  const handleCloseRegisterModal = () => {
    setIsRegisterModalOpen(false);
  };

  const handleClick = (ward) => {
    setSelectedWard(ward);
    setIsModalOpen(true);
  };

  const handleShowInventory = () => {
    setIsModalOpen(false);
    setIsInventoryModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsIndentModalOpen(false);
    setIsDrugConModalOpen(false);
    setIsInventoryModalOpen(false);
  };

  const handleShowIndentRequests = () => {
    const indent = WardsData.find(indent => indent.wardName === selectedWard.wardName);
    if (indent) {
      setSelectedIndent(indent);
      setIsIndentModalOpen(true);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredWards = WardsData.filter((ward) =>
    ward.wardName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const colors = [
    '#0FA4AF',
  ];

  return (
    <div className="ward-cards-container-main">
      <div className="search-bar-container-department">
        <input
          type="text"
          className="search-bar-department"
          placeholder="Search Ward..."
          value={searchQuery}
          onChange={handleSearch}
        />
      </div>

      <button className="add-card-btn-department" onClick={handleOpenRegisterModal}>
        Register a Department
      </button>

      <div className="ward-cards-wrapper-main">
        {filteredWards.map((ward, index) => (
          <div
            key={index}
            className="ward-card-main"
            style={{ backgroundColor: colors[index % colors.length] }}
          >
            <div className="ward-card-logo">
              {/* Image logo for each department */}
              <img
                src={ward.logo || 'https://example.com/default-logo.png'}  // Fallback to default logo if not available
                alt={`${ward.wardName} logo`}
                className="logo-circle"
              />
            </div>
            <h3>{ward.wardName}</h3>
            <button
              onClick={() => handleClick(ward)}
              className="view-details-btn-main"
            >
              View Details
            </button>
          </div>
        ))}
      </div>

      {isInventoryModalOpen && selectedWard && (
        <WardInventoryModal
          wardName={selectedWard.wardName}
          onClose={handleCloseModal}
        />
      )}

      {isModalOpen && selectedWard && (
        <div className="modal-overlay-main" onClick={handleCloseModal}>
          <div className="modal-content-main" onClick={(e) => e.stopPropagation()}>
            <h3>{selectedWard.wardName}</h3>
            <p><strong>Location:</strong> {selectedWard.location}</p>
            <p><strong>Head Doctor:</strong> {selectedWard.headDoctor}</p>
            <h4>Staff:</h4>
            <ul>
              {selectedWard.staff.map((staff, index) => (
                <li key={index}>
                  {staff.name} - {staff.role}
                </li>
              ))}
            </ul>

            <div className="buttons-container-main">
              <button className="show-indent-btn" onClick={handleShowIndentRequests}>
                Show Indent Requests
              </button>
              <button className="show-inventory-btn" onClick={handleShowInventory}>
                Show Inventory
              </button>

              <button className="show-drug-consumption-btn" onClick={() => setIsDrugConModalOpen(true)}>
                Drug Consumption
              </button>
            </div>
          </div>
        </div>
      )}

      {isDrugConModalOpen && selectedWard && (
        <DrugConModal
          wardName={selectedWard.wardName}
          onClose={handleCloseModal}
        />
      )}

      {isIndentModalOpen && selectedIndent && (
        <IndentModal selectedWard={selectedIndent} onClose={handleCloseModal} />
      )}

      {isRegisterModalOpen && (
        <RegisterWardModal
          isOpen={isRegisterModalOpen}
          onClose={handleCloseRegisterModal}
          onAddWard={(newWard) => {
            console.log(newWard);
            setIsRegisterModalOpen(false); // Close the modal after adding a ward
          }}
        />
      )}
    </div>
  );
};

export default WardsModal;
